import { render, staticRenderFns } from "./ElectronicRegistration.vue?vue&type=template&id=4fb5559d&scoped=true"
import script from "./ElectronicRegistration.vue?vue&type=script&lang=js"
export * from "./ElectronicRegistration.vue?vue&type=script&lang=js"
import style0 from "./ElectronicRegistration.vue?vue&type=style&index=0&id=4fb5559d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5559d",
  null
  
)

export default component.exports